import React from "react";
import { Box, IconButton, Paper, TextField, Tooltip } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import MicNoneRoundedIcon from "@mui/icons-material/MicNoneRounded";

const ChatInput = ({ value, onChange, onSend, disabled, placeholder }) => {
  const canSend = value.trim().length > 0 && !disabled;

  const handleSubmit = () => {
    if (!canSend) return;
    onSend(value);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        alignItems: "center",
        border: "1px solid",
        borderColor: "#CFE6DA",
        borderRadius: 99,
        px: 1.5,
        py: 0.6,
        bgcolor: "#FFFFFF",
        boxShadow: "0 6px 18px rgba(22, 74, 56, 0.08)",
      }}
    >
      <TextField
        value={value}
        onChange={(event) => onChange(event.target.value)}
        multiline
        maxRows={6}
        fullWidth
        variant="standard"
        placeholder={placeholder}
        disabled={disabled}
        onKeyDown={(event) => {
          if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            handleSubmit();
          }
        }}
        InputProps={{ disableUnderline: true }}
      />
      <Tooltip title="Voice input">
        <IconButton aria-label="Voice input" disabled={disabled} sx={{ color: "#6B887B", mr: 0.5 }}>
          <MicNoneRoundedIcon />
        </IconButton>
      </Tooltip>
      <Box sx={{ ml: 0.25 }}>
        <Tooltip title="Send">
          <span>
            <IconButton
              color="primary"
              aria-label="Send message"
              onClick={handleSubmit}
              disabled={!canSend}
              sx={{
                width: 42,
                height: 42,
                bgcolor: "primary.main",
                color: "#FFFFFF",
                "&:hover": { bgcolor: "primary.dark" },
                "&.Mui-disabled": { bgcolor: "#DDEBE4", color: "#8DA99B" },
              }}
            >
              <SendIcon />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    </Paper>
  );
};

export default ChatInput;
